// PRESENCE-PRIVACY-V1 (21-9-2026): presence/{uid} kan laeses af alle indloggede (reglen fra 23-8), og hele
// spiller-objektet laa der: rigtigt navn, spaerring, segl, pakke, klasser, fag, alder og rum-adgang. Nu skrives kun
// det, de andre spillere i Campus bruger: navnet i spillet, avatar, rolle, niveau, XP, gilde, broderskab, position og
// rum. De private felter fra foer slettes med deleteField ved hvert login, saa gamle dokumenter heler af sig selv.
// For andre end staff er name det samme som navnet i spillet (name kan ellers vaere kontoens navn eller mail).
import { deleteField } from 'firebase/firestore';
import type { Player } from '../types';
import { isStaff } from './roles';

export const PRESENCE_PRIVATE_FIELDS: string[] = [
  'realName', 'email', 'isBanned', 'isIdentityVerified', 'identityStatus', 'membershipStatus', 'hasHallsAccess',
  'campusPackage', 'packageType', 'ageGroup', 'subjectIds', 'classIds', 'allowedRooms', 'classroomId',
];

export function presencePublic(p: Player): Record<string, any> {
  const out: Record<string, any> = {
    id: p.id,
    name: isStaff(p.role) ? (p.name || p.wizardName || '') : (p.wizardName || ''),
    wizardName: p.wizardName || '',
    avatarUrl: p.avatarUrl || '',
    role: p.role,
    magicalLevel: p.magicalLevel,
    xp: p.xp ?? 0,
    guild: p.guild || '',
    groupId: p.groupId || '',
    x: p.x,
    y: p.y,
    currentRoom: p.currentRoom,
    lastSeen: p.lastSeen,
  };
  PRESENCE_PRIVATE_FIELDS.forEach((k) => { out[k] = deleteField(); });
  return out;
}
